import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");
export const loadAssigneeCandidates = factory<LoadAssigneeCandidatesPayload>("LOAD_ASSIGNEE_CANDIDATES");
export interface LoadAssigneeCandidatesPayload {
	readonly fvKey: string;
}
